/** venture/VicsFundConfirm.tsx — VICS [1329] 보고 검증 및 확정 — 조합 단위로 한 번 (2026-09-24)
 *  투자실적 등록(1313·1319·1320)은 투자 법인마다 하지만, 검증·확정/전송은 조합의 보고를 한 번 보내는 것이다.
 *  그래서 법인 카드가 아니라 13단계 아래에 조합 공통으로 둔다. 완료 체크도 프로젝트(조합) 단위(s13 chk vics_fund_1329). */
import React from 'react';
import { mutStore } from './stepcommon';
import VicsLogin from './VicsLogin';
import { VICS_FUND_STAGE, VICS_FUND_KEY, VICS_CO_STAGES, vicsDoneCount, vicsFundDone } from './vics13';
import type { Project, CoCard } from './types';

interface Props { p: Project; cos: CoCard[]; onPatch: (patch: Partial<Project>) => void; toast: (m: string) => void; }

export default function VicsFundConfirm({ p, cos, onPatch, toast }: Props) {
  const done = vicsFundDone(p);
  const allIn = cos.every((co) => vicsDoneCount(p, co.id) === VICS_CO_STAGES.length);
  const toggle = () => onPatch(mutStore(p, 's13', (s) => { s.chk = s.chk || {}; s.chk[VICS_FUND_KEY] = !s.chk[VICS_FUND_KEY]; }));
  return (
    <div className={'vics fund' + (done ? ' done' : '')} style={{ marginTop: 12 }}>
      <div className="codoc-h">
        <span>🗂 VICS [{VICS_FUND_STAGE.key}] {VICS_FUND_STAGE.title} <span className="s2tag">조합 단위 · 한 번</span></span>
        <span className={'pill ' + (done ? 'p-green' : allIn ? 'p-amber' : 'p-gray')}>{done ? '✓ 확정/전송 완료' : allIn ? '법인 입력 모두 끝 — 전송할 차례' : '법인 입력 진행 중'}</span>
      </div>
      <div className="snote">{VICS_FUND_STAGE.note}</div>
      <div className="vfund-cos">
        {cos.map((co) => {
          const n = vicsDoneCount(p, co.id);
          return <span key={co.id} className={'pill ' + (n === VICS_CO_STAGES.length ? 'p-green' : n ? 'p-amber' : 'p-gray')}>{co.name || '(법인)'} {n}/{VICS_CO_STAGES.length}</span>;
        })}
      </div>
      <VicsLogin p={p} toast={toast} compact />
      <div className="vfoot">
        <span className="grow" />
        <button type="button" className={'chkpill sm ' + (done ? 'on' : '')} onClick={toggle}>{done ? '✓ 확정/전송 완료' : '확정/전송 완료로 표시'}</button>
      </div>
    </div>
  );
}
